<nz-descriptions nzTitle="Buyer Info">
  <nz-descriptions-item nzTitle="Buyer Name">{{
    data.buyerName
  }}</nz-descriptions-item>
  <nz-descriptions-item nzTitle="Mobile">{{
    data.buyerPhone
  }}</nz-descriptions-item>
  <nz-descriptions-item nzTitle="Email">{{
    data.buyerEmail
  }}</nz-descriptions-item>
  <nz-descriptions-item nzTitle="Address">
    {{ data.buyerAddress }}
  </nz-descriptions-item>
  <nz-descriptions-item nzTitle="Date">
    {{ data.createdAt | date: "MMM d, y"}}
  </nz-descriptions-item>
</nz-descriptions>
<nz-divider nzText="Item Details"></nz-divider>
<ng-container *ngFor="let data of data.items">
  <nz-descriptions nzTitle="" nzBordered>
    <nz-descriptions-item nzTitle="Item Name">
      <strong>
        {{ data?.item?.itemName }}
      </strong>
    </nz-descriptions-item>
    
    <nz-descriptions-item nzTitle="Making Cost">{{
      data?.item?.makingCharge | currency : "INR"
    }}</nz-descriptions-item>
    <nz-descriptions-item nzTitle="Metal Price">
      <span nz-typography nzType="success">Curent Price: {{data?.item?.metalRateDetails && data?.item?.metalRateDetails.rate | currency: 'INR'}}/gm</span>
      <br/>
      <!-- <span nz-typography nzType="warning">Old Price: {{itemCopyObj && itemCopyObj[data._id] &&  itemCopyObj[data._id].metalRateDetails && itemCopyObj[data._id].metalRateDetails.rate | currency: 'INR'}}/gm</span> -->
      <span nz-typography nzType="warning">Old Price: {{itemCopyObj && itemCopyObj[data?.item?.itemName] &&  itemCopyObj[data?.item?.itemName].metalRateDetails && itemCopyObj[data?.item?.itemName].metalRateDetails.rate | currency: 'INR'}}/gm</span>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Quantity">
      <strong>
        {{ data?.quantity }}
      </strong>
    </nz-descriptions-item>
    <nz-descriptions-item nzTitle="Final Price">
      <span nz-typography nzType="success">Curent Price: {{data?.item?.finalPrice && data?.item?.finalPrice | currency: 'INR'}}</span>
      <br/>
      <!-- <span nz-typography nzType="warning">Old Price: {{itemCopyObj && itemCopyObj[data._id] &&  itemCopyObj[data._id].finalPrice && itemCopyObj[data._id].finalPrice | currency: 'INR'}}</span> -->
      <span nz-typography nzType="warning">Old Price: {{itemCopyObj && itemCopyObj[data?.item?.itemName] &&  itemCopyObj[data?.item?.itemName].finalPrice && itemCopyObj[data?.item?.itemName].finalPrice | currency: 'INR'}}</span>
    </nz-descriptions-item>
  </nz-descriptions>
  <br />
</ng-container>
